import React, {
    FunctionComponent,
    useEffect,
    useState,
} from "react";
import styles from "./Integrations.module.css";
import { IoIosClose } from "react-icons/io";
import DropdownWithValue from "../DropDown/DropdownWithValue";
import Loading from "../Loading/Loading";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { motion } from "framer-motion";
import Backdrop from "../Backdrop/Backdrop";
import NewButton from "../NewComponents/NewButton/NewButton";
import { themeColors } from "../theme";
import Label from "../Label";
import { updateIntegration } from "../../Services/fbIntegration";
import { showSnackbarAction } from "../../Redux/actions";

type Props = {
    close: () => void;
    open: boolean;
    user: any;
    authToken: any;
    theme: any;
    sheetFields: any;
    integration_name: any;
};

const dropIn = {
    hidden: {
        y: "-100vh",
        opacity: 1,
    },
    visible: {
        y: "0",
        opacity: 1,
        transition: {
            duration: 1,
            type: "spring",
            damping: 25,
            stiffness: 500,
        },
    },
};

const IntegrationMapFields: FunctionComponent<Props> = ({
    close,
    open,
    user,
    authToken,
    theme,
    sheetFields,
    integration_name,
}) => {
    const [load, setLoad] = useState(false);
    const [fields, setFields] = useState<{ label: string; value: string }[]>([]);
    const [selectedValues, setSelectedValues] = useState<{ [key: string]: string }>({
        name: "",
        contact_no: "",
        email: "",
        project: "",
        location: "",
        requirement_Type:"",
        budget: "",
        property_type: "",
    });

    const dispatcher = useDispatch();
    const history = useHistory();

    const customStyles = {
        content: {
            backgroundColor: theme ? themeColors.dropdownBackgroundColor : themeColors.dropdownBackgroundColorDark,
            color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
        },
    };
    const containerStyles = {
        backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark,
        color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
        maxHeight: "400px",
    };

    useEffect(() => {
        const formattedFields = sheetFields.map((field: any) => ({
            label: field,
            value: field,
        }));
        setFields(formattedFields);
    }, [sheetFields]);

    const handleSelect = (field: string, value: string) => {
        setSelectedValues((prevValues) => ({
            ...prevValues,
            [field]: value,
        }));
    };

    const getFilteredOptions = (field: string) => {
        const selected = Object.values(selectedValues).filter((val) => val !== "Select" && val !== selectedValues[field]);
        return fields.filter((option) => !selected.includes(option.value));
    };

    const mapFields = () => {
        let integration_mapped_fields = {
            customer_name: selectedValues.name,
            email: selectedValues.email,
            contact_no: selectedValues.contact_no,
            requirement_Type: selectedValues.requirement_Type,
            location: selectedValues.location,
            project: selectedValues.project,
            budget: selectedValues.budget,
            property_type: selectedValues.property_type,
        };
        if(selectedValues.name===""||selectedValues.name===undefined ||selectedValues.contact_no===""||selectedValues.contact_no===undefined){
            dispatcher(
                showSnackbarAction("Customer Name & Contact Number Required","error")
            );
        }else{updateIntegration(
            integration_name,
            user.organization_id,
            { integration_mapped_fields, integration_status: "ACTIVE" },
            dispatcher,
            setLoad,
        );
        close()}
    
    };
    return (
        <>
            {load && <Loading />}
            {open && (
                <Backdrop>
                    <motion.div
                        key="modal"
                        className="card p-4 shadow rounded"
                        style={{
                            position: "absolute",
                            minWidth: "400px",
                            ...containerStyles,
                        }}
                        variants={dropIn}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                    >
                        <div className={styles.firstDiv}>
                            <h5> Data Mapping</h5>
                            <div className={styles.cross} onClick={close}>
                                <IoIosClose size={35} color={"#808080"} />
                            </div>
                        </div>
                        <div className={styles.line}></div>
                        <div style={{ overflowY: "auto" }}>
                            {[
                                { label: "Customer Name", stateKey: "name",required:true },
                                { label: "Contact Number", stateKey: "contact_no",required:true },
                                { label: "Email", stateKey: "email",required:false },
                                { label: "Project", stateKey: "project",required:false },
                                { label: "Location", stateKey: "location",required:false },
                                { label: "Requirement Type", stateKey: "requirement_Type" ,required:false},
                                { label: "Budget", stateKey: "budget",required:false },
                                { label: "Property Type", stateKey: "property_type",required:false },
                            ].map(({ label, stateKey,required }) => (
                                <div className={styles.box2} key={stateKey}>
                                    <div className={styles.divide} style={{ width: "100%" }}>
                                        <Label label={label} required={required} />
                                        <div style={{ marginTop: "7px" }}>
                                            <DropdownWithValue
                                                option={getFilteredOptions(stateKey)}
                                                selectedValue={{
                                                    label: selectedValues[stateKey],
                                                    value: selectedValues[stateKey],
                                                }}
                                                setSelectedValue={(value) => handleSelect(stateKey, value.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <NewButton title="Save" onClick={mapFields} />
                    </motion.div>
                </Backdrop>
            )}
        </>
    );
};

const mapStateToProps = (state: any) => {
    return {
        user: state.user.data,
        theme: state.theme.isLightMode,
        authToken: state.user.authToken,
    };
};

export default connect(mapStateToProps)(IntegrationMapFields);
